module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/LED Module.cc51a792.png";